"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var DropDown_1 = __importDefault(require("../../common/DropDown/DropDown"));
var icons_1 = __importDefault(require("../../theme/icons"));
var react_i18next_1 = require("react-i18next");
function RoleSelector(props) {
    var roles = (0, react_1.useState)([
        {
            value: 3,
            label: "Administrator",
        },
        {
            value: 11,
            label: "Agent",
        },
    ])[0];
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { style: {
            margin: "0.31rem 0",
            display: "flex",
            flex: 1,
            width: "100%",
            flexDirection: "column",
        } },
        props.error && react_1.default.createElement("p", { className: "error" }, props.error),
        react_1.default.createElement(DropDown_1.default, { defaultValue: props.defaultValue, icon: react_1.default.createElement(icons_1.default, { className: "icon_orange", height: 32, name: "role", width: 32 }), name: t("role"), onChange: props.onChange, options: roles, value: props.value })));
}
RoleSelector.propTypes = {
    error: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    style: prop_types_1.default.object,
    className: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    defaultValue: prop_types_1.default.any,
    value: prop_types_1.default.any,
};
exports.default = RoleSelector;
